var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"tag",staticClass:"o-contact-info | t-regular"},[_vm._v("\n    "+_vm._s(_vm.email)),_c('br'),_vm._v("\n    "+_vm._s(_vm.phone)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }